import React from "react";
import ResImg from "../resImg";
import ResVideo from "../resVideo";
import Link from "../../utils/link";


const SlideshowSlide = (props) => {

    const block = props.block

    const hasVideo = block.desktop_video?.filename != undefined && block.desktop_video?.filename != ""

    const headerColor = block.header_color || "white"

    const critical = props.index == 0 ? true : false

    return (
        <>
            {hasVideo ? (
                <ResVideo mobileVideo={block.mobile_video} desktopVideo={block.desktop_video} mobilePoster={block.mobile_image} desktopPoster={block.desktop_image} />
            ) : (
                <ResImg mobile={block.mobile_image} desktop={block.desktop_image} critical={critical} className='swiper-gl-image'/>
            )}
            <div className={`w-full ${headerColor == 'white' ? `text-white` : `text-black`} absolute bottom-5 lg:bottom-7 left-0 width flex justify-between lg:grid lg:grid-cols-3 text-xs lg:text-base bottom-bar`}>
                {block.title != "" && (
                    <p className="font-semibold title">
                        {block.title}
                    </p>

                )}
                {block.copy != "" && (
                    <p className="text-right lg:text-center copy">
                        {block.copy}
                    </p>

                )}
            </div>
            
            {
                block.linked_page != null && block.linked_page.cached_url != "" && (
                    <Link to={block.linked_page.cached_url} className="absolute top-0 left-0 w-full h-full z-10">
                        <span className="sr-only">{block.title}</span>
                    </Link>
                )
            }

        </>
    )
}

export default SlideshowSlide